import { store } from "Models/Store";
import { RouteComponentProps } from "react-router";
import { ILink } from "./Components/Navigation/Navigation";
import ProductSwitcher from "./Components/Navigation/ProductSwitcher";

export default function ApproveNavLinks(pageProps: RouteComponentProps): ILink[][] {

	return [
		[
			{
				label: 'Product Switcher',
				customComponent: (
					<ProductSwitcher productClass="approve" />
				),
				path: '/',
				icon: 'home',
				iconPos: 'icon-left',
			},
		],
		[
			{
				label: 'Dashboard',
				path: '/approve/dashboard',
			},
			{
				label: 'Applications',
				path: '/approve/customerapplications',
			},
		],
		[
			{
				label: 'Login',
				path: '/login',
				icon: 'login',
				iconPos: 'icon-right',
				shouldDisplay: () => !store.loggedIn,
				className: 'login-logout-btn',
			},
			{
				label: 'Logout',
				path: '/logout',
				icon: 'logout',
				iconPos: 'icon-right',
				shouldDisplay: () => store.loggedIn,
				className: 'login-logout-btn',
			},
		],
	]
}